/*
 * 统一管理从服务端获取的数据，方便后期维护
 * 通过export  暴露封装的获取数据方法
 */
import Axios from "axios";

const industryAnalyze = process.env.VUE_APP_SERVER_URL

// 获取企业地图详情
export const infoApi = (data) => Axios.get(industryAnalyze + '/ent-bj/bjEnt', data)
